import apiMaintenanceSchedule from 'services/inventory/maintenance-schedule'

export const handleRemoveInspection = async (maintenanceScheduleId: string, inspectionId: string) => {
  let res = await apiMaintenanceSchedule.removeInspection(maintenanceScheduleId, inspectionId)

  return res?.data?.success
}
